// Icon: material-symbols:animated-images-outline
// Slug: Runs an expression on every animation frame.
// Description: Runs an expression on every `requestAnimationFrame` event.

import { attribute } from '@engine'
import { beginBatch, endBatch } from '@engine/signals'
import { modifyTiming } from '@utils/timing'
import { modifyViewTransition } from '@utils/view-transitions'

attribute({
  name: 'on-raf',
  requirement: {
    key: 'denied',
    value: 'must',
  },
  apply({ mods, rx }) {
    let callback = () => {
      beginBatch()
      rx()
      endBatch()
    }
    callback = modifyViewTransition(callback, mods)
    callback = modifyTiming(callback, mods)
    let rafId: number | undefined
    const raf = () => {
      callback()
      rafId = requestAnimationFrame(raf)
    }
    rafId = requestAnimationFrame(raf)
    return () => {
      if (rafId) {
        cancelAnimationFrame(rafId)
      }
    }
  },
})
